module.exports = __webpack_public_path__ + "static/bg_144_teddy_air_balloon-48f8a4904ce915fabf71681ad3f6d184.webp";